import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const modules = [{
  title: 'Fondations de la Gymnastique Artistique™',
  description: "Maîtrisez les bases pédagogiques de l'enseignement grâce à une méthode claire, des progressions techniques et des principes essentiels pour construire des apprentissages solides à tous les niveaux."
}, {
  title: "Bibliothèque Complète d'Exercices™",
  description: "Accédez à une vaste bibliothèque d'exercices classés par agrès, niveau et objectif afin de renouveler facilement vos entraînements tout au long de l'année."
}, {
  title: 'Système de Planification des Séances™',
  description: "Créez rapidement des séances professionnelles grâce à des structures, modèles et plans prêts à l'emploi qui vous feront gagner un temps précieux."
}, {
  title: 'Séances Prêtes à Utiliser™',
  description: "Profitez d'une collection complète de séances déjà préparées, facilement adaptables selon l'âge, le niveau et les objectifs de vos gymnastes."
}, {
  title: 'Programmes de Progression™',
  description: 'Accompagnez chaque gymnaste avec des progressions structurées permettant de développer progressivement les compétences techniques tout au long de la saison.'
}, {
  title: 'Kit Complet du Professeur™',
  description: "Retrouvez toutes les fiches d'évaluation, feuilles de suivi, check-lists, outils d'organisation et documents indispensables pour gérer vos entraînements comme un professionnel."
}];
export function SolutionSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white border-y-4 border-brand-ivory" data-id="element-152">
      <div className="text-center mb-4" data-id="element-153">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-154">
          LA SOLUTION QUE VOUS ATTENDIEZ
        </h2>
        <p className="text-sm sm:text-base font-heading font-bold text-brand-violet mb-2 uppercase tracking-wide leading-tight" data-id="element-155">
          UN SYSTÈME COMPLET DE PLANIFICATION 6-EN-1 POUR LES PROFESSEURS DE
          GYMNASTIQUE ARTISTIQUE
        </p>
        <p className="text-sm text-brand-text font-bold mb-3" data-id="element-156">
          6 Modules Professionnels réunis dans un seul système complet.
        </p>
        <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-md mb-3 shadow-sm" data-id="element-157">
          <p className="font-heading font-bold text-sm tracking-wide" data-id="element-158">
            🤸 GYMNASTIQUE PRO™
          </p>
        </div>
        <h3 className="text-base sm:text-lg font-heading font-extrabold text-brand-navy mb-2 leading-tight" data-id="element-159">
          Le Système Complet de Planification 6-en-1 pour les Professeurs de
          Gymnastique Artistique
        </h3>
        <div className="text-sm sm:text-base text-brand-text font-medium leading-snug max-w-xl mx-auto space-y-1" data-id="element-160">
          <p data-id="element-161">
            GYMNASTIQUE PRO™ est bien plus qu'une simple collection
            d'exercices.
          </p>
          <p data-id="element-162">
            C'est un système professionnel conçu pour aider les professeurs de
            gymnastique artistique à préparer leurs entraînements plus
            rapidement, construire des progressions efficaces, organiser le
            développement de leurs gymnastes, planifier leur saison et enseigner
            chaque séance avec davantage de confiance.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-2.5" data-id="element-163">
        {modules.map(module => <article key={module.title} className="bg-brand-ivory border border-brand-border p-3.5 rounded-lg flex gap-3 items-start shadow-sm" data-id="element-164">
            <CheckCircle2Icon className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-165" />
            <div data-id="element-166">
              <h3 className="text-sm sm:text-base font-heading font-bold text-brand-navy leading-tight mb-1" data-id="element-167">
                ✅ {module.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-snug" data-id="element-168">
                {module.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}